import React from 'react'
// eslint-disable-next-line
import { useMapsLibrary } from '@vis.gl/react-google-maps/dist/index.umd.js'
import { useDispatch } from 'react-redux'
import {
  setDirectionRoutes,
  setDirectionsRendererGlobal,
} from '../../redux/myMapsSlice'

const Directions = ({ map, origin, destination }) => {
  const dispatch = useDispatch()
  const routesInstance = useMapsLibrary('routes')
  const [directionsService, setDirectionsService] = React.useState(null)
  const [directionsRenderer, setDirectionsRenderer] = React.useState(null)

  React.useEffect(() => {
    if (!routesInstance || !map) return

    const service = new routesInstance.DirectionsService()
    const renderer = new routesInstance.DirectionsRenderer({
      map,
      polylineOptions: {
        strokeColor: '#CC5500',
        strokeWeight: 6,
        strokeOpacity: 1,
      },
    })

    setDirectionsService(service)
    setDirectionsRenderer(renderer)
    dispatch(setDirectionsRendererGlobal(renderer))

    // Cleanup on unmount
    // eslint-disable-next-line consistent-return
    return () => {
      renderer.setMap(null)
    }
  }, [routesInstance, map])

  React.useEffect(() => {
    if (!directionsService || !directionsRenderer) return
    directionsService
      .route({
        origin,
        destination,
        // eslint-disable-next-line no-undef
        travelMode: window.google.maps.TravelMode.DRIVING,
        provideRouteAlternatives: true,
      })
      .then((response) => {
        dispatch(setDirectionRoutes(response.routes))
        directionsRenderer.setDirections(response)
      })
  }, [directionsService, directionsRenderer])

  if (!map) return null
  return null
}

export default Directions
